import { LifeCycleCore } from './lifeCycleCore'

export const LifeCycleModule = {
  config(Vue, store) {
    Vue.$lifeCycleCore = Vue.prototype.$lifeCycleCore = new LifeCycleCore(store)
  }
}